import { bl_fi_mst_item_far_depreciation_event_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class FinancialItemDepreciationEventContainerModel extends BaseContainerModel {
    bl_fi_mst_item_far_depreciation_event: bl_fi_mst_item_far_depreciation_event_RowClass = new bl_fi_mst_item_far_depreciation_event_RowClass();
}